import {findOverflowingScrollParent} from '../../../libs/shared/core/src/helpers/browser/domHelpers';
import {RecipientRolesEnum} from '../../../libs/shared/core/src/models/api/recipientModel';
import {isExistingModifier, ModifiersEnum} from './searchModifiersHelpers';

/*
 * Constants.
 */

export const searchFocusedAttribute = 'data-search-focused';

export const searchableAttribute = 'data-searchable';

export const searchIdAttribute = 'data-search-id';

export const searchableAttrsSubject = {
  [searchableAttribute]: true,
  [`${searchableAttribute}-${ModifiersEnum.SUBJECT}`]: true,
};

export const searchableAttrsBody = {
  [searchableAttribute]: true,
  [`${searchableAttribute}-${ModifiersEnum.BODY}`]: true,
};

export const searchableAttrsFrom = makeSearchableAttrsForRole(RecipientRolesEnum.FROM);

/*
 * Helpers.
 */

export function makeSearchableAttrsForRole(role: RecipientRolesEnum) {
  const searchableAttrs: Record<string, boolean> = {
    [searchableAttribute]: true,
    [`${searchableAttribute}-${ModifiersEnum.RECIPIENT}`]: true,
  };

  // If role has a related modifier, add it as a searchable attribute.
  if (isExistingModifier(role)) {
    searchableAttrs[`${searchableAttribute}-${role}`] = true;
  }

  return searchableAttrs;
}

export function makeSearchIdAttribute(id: string | number | undefined) {
  return {
    [searchIdAttribute]: String(id),
  };
}

export function getSearchIdAttribute(element: Element) {
  return element.getAttribute(searchIdAttribute) ?? undefined;
}

export function setFocusedAttribute(element: Element) {
  element.setAttribute(searchFocusedAttribute, 'true');
}

export function removeFocusedAttribute(element: Element) {
  element.removeAttribute(searchFocusedAttribute);
}

/** Unfocus the focused element, if any. */
export function clearFocused(results: ReadonlyArray<Element>) {
  results.forEach(removeFocusedAttribute);
}

export function isElementVisible(element: Element): boolean {
  const scrollParent = findOverflowingScrollParent(element);
  const parentRect = scrollParent && scrollParent.getBoundingClientRect();
  if (!parentRect) {
    return false;
  }

  const elementRect = element.getBoundingClientRect();
  return elementRect.top >= parentRect.top && elementRect.bottom <= parentRect.bottom;
}

export function scrollIntoView(element: Element) {
  element.scrollIntoView({behavior: 'auto', block: 'nearest'});
}
